import "core-js/modules/es.array.push.js";
import { captureException } from "@sentry/vue";
export default {
  name: "AdminHeader",
  data: function data() {
    return {
      navigationDrawerOpen: false
    };
  },
  methods: {
    logout: function logout() {
      var _this = this;
      this.$http.post('signOut').then(function () {
        _this.$store.dispatch('authLogout').then(function () {
          _this.$router.push({
            path: '/login'
          });
        });
      }).catch(function (error) {
        return captureException(error);
      });
    }
  }
};